
/* injects from baggage-loader */

const moduleAlert = angular.module('create.link.controller', []);
moduleAlert.controller('LinkCreateModal', [
  "$scope", "$state", "$modalInstance", "$stateParams", "parentId", "widget", "$filter",
  ($scope, $state, $modalInstance, $stateParams, parentId, widget, $filter) => {
    $scope.newlink = {
      click_action: "open_link",
      name: "",
      link_href_target: "blank"
    };

    $scope.create = (newlink, form) => {
      if (form.$invalid) {
        return false;
      }

      if (parentId) {
        newlink.has_parent = true;
        newlink.parent_id = parentId;
      }

      addLinkToCollection(newlink);
      $scope.close();
    };

    $scope.pageSelect = (path) => {
      $scope.newlink.url = "/" + angular.copy(path);
    };

    const addLinkToCollection = (link) => {
      console.log({widget, link});

      if (link.has_parent) {
        const list = _.filter(widget.links_attributes, { id: link.parent_id });
        const index = widget.links_attributes.indexOf(list[0]);

        if (index > -1) {
          link.position = widget.links_attributes.length;
          return widget.links_attributes[index].links_attributes.push(link);
        }
      } else {
        link.position = widget.links_attributes.length;
        return widget.links_attributes.push(link);
      }
    };

    $scope.close = () => {
      $modalInstance.dismiss("close");
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/navigationfields/link.create.controller.js